export default __webpack_public_path__ + "static/ProValue_1@768-c33150dc64207465ef0b138a6ba1fa08.webp";